import React from 'react'
import { useState } from 'react'
import FileUploadedList from './FileUploadedList'
import MyButton from '../../UI/form/MyButton'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import { isFilesHaveFormat } from '../../../helpers/file/FileHelper'

// const FileUpload = ({ setFilesExt, accept = 'image' }) => {
const FileUpload = ({ setFilesExt, accept = '' }) => {

    const [drag, setDrag] = useState(false)
    const [files, setFiles] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')

    // console.log('files', files)

    const dragStart = (e) => {
        e.preventDefault()
        setDrag(true)
    }

    const dragLeave = (e) => {
        e.preventDefault()
        setDrag(false)
    }

    const drop = (e) => {
        e.preventDefault()
        setError('')
        setIsLoading (true)
        const formData = new FormData()
        const files = [...e.dataTransfer.files]
        for (const i in files) {
            formData.append('file' + i, files[i])
        }
        console.log('files', files)
        if (isFilesHaveFormat({ type: accept, files })) {
            setFiles(files)
            setFilesExt(files)
        } else {
            setError('Файли мають формат відмінний від: ' + accept + '/*')
            cancel()
        }
        setIsLoading (false)
        // saveFiles(formData)

        setDrag(false)
    }

    const fileUploadClick = () => {
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', accept + '/*')
        input.setAttribute('multiple', true) // ✅ дозволяємо кілька файлів
        input.click()

        // input.onchange = function () {
        //     const files = Array.from(input.files) // перетворюємо FileList у масив
        //     const formData = new FormData()
            
        //     files.forEach((file) => {
        //         formData.append('files', file) // ✅ додаємо всі файли
        //     })

        //     setFiles(files)
        //     setFilesExt(files)
        //     setIsLoading(false)
        // }

        input.onchange = function () {
            const files = Array.from(input.files) // перетворюємо FileList у масив
            const formData = new FormData()
            
            for (const i in files) {
                formData.append('file' + i, files[i])
            }
            console.log('files', files)
            if (isFilesHaveFormat({ type: accept, files })) {
                setFiles(files)
                setFilesExt(files)
            } else {
                setError('Файли мають формат відмінний від: ' + accept + '/*')
                cancel()
            }
            setIsLoading (false)
        }
        
        // input.onchange = function () {
        //     const file = input.files[0]
        //     const formData = new FormData()
        //     formData.append('file', file)
        //     setFiles([file])
        //     setFilesExt([file])
        //     setIsLoading (false)
        // }
    }

    const cancel = () => {
        setFiles([])
        setFilesExt([])
    }

  return (
    <div>
        {
            files && files.length > 0 ?
                <MyButton 
                    onClick={cancel}
                    color='red'
                    classNameAdditional={'fileUploadClearButton'}
                >
                    Видалити файли
                </MyButton>
            : ''
        }

        {
            drag ?
                <div 
                    className='upload__drag upload__drag-active'
                    onDragStart={e => dragStart(e)}
                    onDragLeave={e => dragLeave(e)}
                    onDragOver={e => dragStart(e)}
                    onDrop={e => drop(e)}
                >
                    Відпусти, щоб завантажити файли
                </div>
            :
                files && files.length > 0 ?
                    <FileUploadedList 
                        files={files}
                    />
                :
                    <div 
                        className={files.length > 0 ? 'upload__drag upload__drag-success' : 'upload__drag'}
                        // className={'upload__drag upload__drag-success'}
                        onDragStart={e => dragStart(e)}
                        onDragLeave={e => dragLeave(e)}
                        onDragOver={e => dragStart(e)}
                        onClick={fileUploadClick}
                    >
                        {
                            // files.length > 0 && !isLoading ? 
                            // imagesUploaded.length > 0 && !isLoading ? 'Файли завантажено' :
                            isLoading ? 'Триває завантаження ...' :
                            'Перенеси сюди файли, для завантаження'
                        }
                    </div>
        }
        <ErrorMessage error={error} />
        {/* {
            imagesUploaded && imagesUploaded.length > 0 ?
                <ImageUploadList images={imagesUploaded} />
            : ''
        } */}
    </div>
  )
}

export default FileUpload